export default __webpack_public_path__ + "static/media/albumsBanner.5b8bacc8.png";